import 'react-toastify/dist/ReactToastify.css';
import React from "react";
import "service/Notifications.scss";
import {ToastContainer, toast, Slide} from 'react-toastify';
import {Icons} from "../utils/Icons";

const ToastContent = ({title, message, iconEl}) => (
    <div className="acx-toast">
        {iconEl}
        <div className="acx-toast__text">
            {title && <div className="acx-toast__title">{title}</div>}
            <div className="acx-toast__message">{message}</div>
        </div>
    </div>
);

const opts = (message, retry) => ({autoClose: retry, toastId: message});

export default class Notifications {
    static info = (message, title = "", retry = 3000) => {
        toast.dismiss();
        toast.info(
            <ToastContent title={title} message={message} iconEl={Icons.info('acx-toast__icon acx-toast__icon--info')}/>,
            opts(message, retry)
        );
    };

    static success = (message, title = "", retry = 3000) => {
        toast.dismiss();
        toast.success(
            <ToastContent title={title} message={message} iconEl={Icons.check('acx-toast__icon acx-toast__icon--success')}/>,
            opts(message, retry)
        );
    };

    static error = (message, title = "", retry = 8000) => {
        toast.dismiss();
        toast.error(
            <ToastContent title={title} message={message} iconEl={Icons.alert('acx-toast__icon acx-toast__icon--error')}/>,
            opts(message, retry)
        );
    };

    static warn = (message, title = "", retry = 3000) => {
        toast.dismiss();
        toast.warn(
            <ToastContent title={title} message={message} iconEl={Icons.alert('acx-toast__icon acx-toast__icon--warn')}/>,
            opts(message, retry)
        );
    };
}

const CloseButton = () => Icons.cross('acx-toast__close');

export const NotificationsContainer = () => (
    <ToastContainer
        closeButton={CloseButton}
        hideProgressBar
        pauseOnHover
        limit={3}
        pauseOnFocusLoss={false}
        transition={Slide}
        draggable={false}
        position="bottom-right"
    />
);
